import type { ApiNodeDataExternalApi, VendorIntegration } from '@onefootprint/request-types/dashboard';
import type { VendorIntegrationFormData } from '../types';
import { bodyJsonToInputs, encodeFormKey, getIntegrationInputNodes, getLeafFields } from './integration-schema';

// `ExternalApiConfig` generates as bare `HttpProperties` (the rest of the struct is `serde(flatten)`ed
// away), so the fields beyond the HTTP ones have to be read off an untyped view of the config.
type RawConfig = { workflowDataAssignments?: Array<{ key: string; rule: unknown }> };

export const getDefaultValues = ({
  node,
  integrations,
}: {
  node: { data: ApiNodeDataExternalApi };
  integrations: VendorIntegration[];
}): VendorIntegrationFormData => {
  const source = node.data.source;
  const vendorIntegration = typeof source === 'object' && 'vendorIntegration' in source ? source.vendorIntegration : {};
  const integrationKind = vendorIntegration.kind;
  const selectedApi = integrations.flatMap(i => i.apis).find(a => a.kind === integrationKind);

  const assignments = (node.data.config as unknown as RawConfig).workflowDataAssignments ?? [];
  const outputMappings: Record<string, string> = {};
  for (const a of assignments) {
    const rule = a.rule as { jsonPath?: { selector?: string } };
    const path = (rule.jsonPath?.selector ?? '').replace(/^\$\.?/, '');
    if (path) outputMappings[encodeFormKey(path)] = a.key;
  }

  return {
    config: {
      integrationKind,
      useIntegrationSandboxMock: !!vendorIntegration.useMockData,
      integrationInputs: bodyJsonToInputs(
        node.data.config.body,
        getLeafFields(getIntegrationInputNodes(selectedApi?.inputSchema)),
      ),
      integrationMockData: bodyJsonToInputs(
        vendorIntegration.useMockData,
        getLeafFields(getIntegrationInputNodes(selectedApi?.outputSchema)),
      ),
      outputMappings,
    },
  };
};
